module.exports = "/images/warning@2x.png?a778e8edc33a20d1be13698b6929a6ec";